import { OrderPlanningOrders } from "../planning/opsmgmt/OrderPlanningOrders";
import { Button, CityState, DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadMatch extends Layout {
    buttonExpand: Button;
    buttonSearch: Button;
    citystateM: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacerSearch: HorizontalSpacer;
    labelCategory: Label;
    labelCurrentDispatch: Label;
    labelDriveAvailToday: Label;
    labelDriveAvailTodayValue: Label;
    labelDriverHomeLocationValue: Label;
    labelDutyStatus: Label;
    labelDutyStatusValue: Label;
    labelEquipmentGroupcurrentmovementId: Label;
    labelFinalPreassignDestination: Label;
    labelFinalPreassignDestinationValue: Label;
    labelFinalStop: Label;
    labelFinalStopValue: Label;
    labelFullName: Label;
    labelHLocation: Label;
    labelHoursOfService: Label;
    labelLastClearedStop: Label;
    labelLastClearedStopValue: Label;
    labelLastLocationValue: Label;
    labelLastUpdateRetrieved: Label;
    labelOnDutyAvailToday: Label;
    labelOnDutyAvailTodayValue: Label;
    labelPTA: Label;
    labelPTAValue: Label;
    labelPreassigned: Label;
    labelPreassignedValue: Label;
    labelPreassignments: Label;
    labelProgressOrder: Label;
    labelProgressOrderValue: Label;
    labelSearchTitle: Label;
    labelT: Label;
    layoutMatchingLoads: OrderPlanningOrders;
    layoutNonMatchingLoads: OrderPlanningOrders;
    panelDriveAvailToday: Panel;
    panelDutyStatus: Panel;
    panelFilterParams: Panel;
    panelFilters: Panel;
    panelFinalPreassignDestination: Panel;
    panelFinalStop: Panel;
    panelHeader1: Panel;
    panelHeader2: Panel;
    panelHeader3: Panel;
    panelHeader4: Panel;
    panelHeader: Panel;
    panelLastClearedStop: Panel;
    panelLastUpdateRetrieved: Panel;
    panelOnDutyAvailToday: Panel;
    panelPTA: Panel;
    panelPreassigned: Panel;
    panelProgressOrder: Panel;
    sourceLoadMatch: DataSource;
    tabTabM: Tab;
    tabTabNM: Tab;
    tabsetLM: Tabset;
    textboxPriorityOne: Textbox;
    textboxPriorityOneValue: Textbox;
    textboxPriorityTwo: Textbox;
    textboxPriorityTwoValue: Textbox;
}
